import React from "react";

import { useSessionStorage } from "./services/useSessionStorage";

const transformUsers = (users = []) => {
  return users
    .map((user) => {
      return {
        ...user,
        name: `${[user.lastName, user.firstName].join(", ")}`,
      };
    })
    .sort((a, b) =>
      a.name.localeCompare(b.name, "en", { sensitivity: "base" }),
    );
};

const UsersContext = React.createContext();

const useUsersContext = (client) => {
  const [context, setContext] = useSessionStorage("users", []);
  if (!context?.length) {
    console.time("Querying for Users");
    client
      .query(getUsersQuery)
      .toPromise()
      .then((response) => {
        if (response.error) throw new Error(response.error);
        setContext(transformUsers(response.data?.users));
        console.timeEnd("Querying for Users");
      })
      .catch((e) => {
        if (/Token has expired\./.test(e.toString()))
          window.location.replace("/logout.html");
      });
  }
  return [context, setContext];
};

const getUsersQuery = `
  query GetUsers {
    users {
      azureId
      id
      firstName
      lastName
      programAccess {
        program
        reviewTypes
      }
    }
  }`;

export { transformUsers, UsersContext, useUsersContext };
